import React, { useState, useMemo, useEffect } from "react";
import ResultStreamDataTable from "./result_stream_dataTable";
import ResultComponentTable from "./result_stream_component_table";
import SingleStreamView from "./SingleStreamView";
import designResult from '@/constants/design.json';
import "./calculateTask3LG.less";
import { Button } from "antd";

interface Props {
  input: any;
  results: any;
}

// 按流股名称配对设计值与计算值
const mergeDesignWithCalc = (design: any, calc: any) => {
  const calcStreams = calc?.streams ?? [];
  const designStreams = design?.streams ?? [];

  return calcStreams.map((calcStream: any) => {
    const ds = designStreams.find((s: any) => s.name === calcStream.name) ?? {};
    return {
      ...calcStream,
      design: ds,
    };
  });
};

const CalculateTask3LG: React.FC<Props> = ({ input, results }) => {
  const [isHide, setIsHide] = useState(true);
  const [selectedStreams, setSelectedStreams] = useState<string[]>([]);
  const calcStreams = results?.streams ?? [];

  // 初始化全选
  useEffect(() => {
    if (calcStreams.length > 0) {
      // setSelectedStreams(calcStreams.map((s: any) => s.name));//初始化全选
      setSelectedStreams([calcStreams[0].name]); // 只选第一个
      console.log(calcStreams[0].name);
    }
  }, [calcStreams]);

  // 全选/取消全选
  const handleSelectAll = () => {
    if (selectedStreams.length === calcStreams.length) {
      setSelectedStreams([]);
    } else {
      setSelectedStreams(calcStreams.map((s: any) => s.name));
    }
  };

  // 单选/取消单选
  const toggleStream = (name: string) => {
    setSelectedStreams(prev =>
      prev.includes(name) ? prev.filter(n => n !== name) : [...prev, name]
    );
  };

  // 合并设计值+计算值，并过滤选中流股
  const mergedStreams = useMemo(() => {
    const filtered = calcStreams.filter((s: any) => selectedStreams.includes(s.name));
    return mergeDesignWithCalc(designResult, { streams: filtered });
  }, [results, selectedStreams, designResult]);
  const handleSingleSelect = (name: string) => {
    setSelectedStreams([name]);
    console.log(name);
  };

  // 判断是否为单选状态
  const isSingleStream = mergedStreams.length === 1;
  const singleStreamData = isSingleStream ? mergedStreams[0] : null;

  return (
    <div className="calculate-task-containerLg">
      <div className="main-layout">
        {/* 左侧流股选择栏（复用原有逻辑） */}
        <div className="stream-list-sidebar">
          <div className="sidebar-header">
            <label className="select-all-label">
              <input
                type="checkbox"
                checked={selectedStreams.length === calcStreams.length && calcStreams.length > 0}
                onChange={handleSelectAll}
              />
              <span>全选</span>
            </label>
          </div>
          <div className="stream-list">
  {calcStreams.map((s: any) => (
    // 1. 把外层 label 改成 div，取消整行绑定
    <div key={s.name} className={`stream-item ${selectedStreams.includes(s.name) ? 'active' : ''}`} onClick={(e) => {handleSingleSelect(s.name);e.stopPropagation()}}>
      {/* 2. 只给 checkbox 套 label，确保只有点框才生效 */}
      <label>
        <input
          type="checkbox"
          checked={selectedStreams.includes(s.name)}
          onChange={() => toggleStream(s.name)}
          onClick={(e) => e.stopPropagation()}
        />
      </label>
      {/* 3. 文字纯展示，不触发选择 */}
      <span className="stream-name" >
        {s.name}
      </span>
    </div>
  ))}
</div>
        </div>

        {/* 右侧内容区：根据选中数量切换布局 */}
        <div className="data-content-area" style={{ position: 'relative' }}>
          <Button className="hide-design-btn" type="primary" onClick={() => setIsHide(!isHide)}>
            {isHide ? '显示设计值' : '隐藏设计值'}
          </Button>
          {isSingleStream && singleStreamData ? (
            // 单选：卡片式布局
            <SingleStreamView stream={singleStreamData} input={input} isHide={isHide} />
          ) : (
            // 多选：表格布局（复用原有组件）
            <>
              <div className="data-section">
                <ResultStreamDataTable streams={mergedStreams} isHide={isHide} />
              </div>
              <div className="data-section">
                <ResultComponentTable streams={mergedStreams} input={input} isHide={isHide} />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalculateTask3LG;